import { AcadNavTabs } from "@components";
import routes from "./ScholarshipRoutes";

const Scholarships = () => {
  return <AcadNavTabs routes={routes} />;
};

export default Scholarships;
